import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteDocumentActions'
import * as api from '../../api/job/jobSiteDocuments'

//new ones
function* jobSiteDocumentsFetch(action) {
  try {
    const params = {
      jobId: action.jobId,
      folderId: action.folderId || null
    }
    const payload = yield call(api.fetchJobSiteDocuments, params)
    yield put({ type: constants.JOB_SITE_DOCUMENTS_FETCH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENTS_FETCH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteDocumentsFetch() {
  yield takeLatest(constants.JOB_SITE_DOCUMENTS_FETCH.ACTION, jobSiteDocumentsFetch)
}

// old ones
function* jobSiteDocumentsRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteDocuments, action.jobId)
    yield put({ type: constants.JOB_SITE_DOCUMENTS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteDocuments() {
  yield takeLatest(constants.JOB_SITE_DOCUMENTS_REFRESH.ACTION, jobSiteDocumentsRefresh)
}

function* jobSiteDocumentsS3(action) {
  try {
    const payload = yield call(api.getJobSiteDocumentsS3, action.pathId)
    yield put({ type: constants.JOB_SITE_DOCUMENTS_S3.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENTS_S3.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteDocumentsS3() {
  yield takeLatest(constants.JOB_SITE_DOCUMENTS_S3.ACTION, jobSiteDocumentsS3)
}

function* sagaCreateJobSiteDocument(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.content,
      file: action.file,
      filename: action.filename,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createJobSiteDocument, payload)
    yield put({ type: constants.JOB_SITE_DOCUMENT_CREATE.SUCCESS, payload })
    yield call(jobSiteDocumentsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENT_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteDocument() {
  yield takeLatest(constants.JOB_SITE_DOCUMENT_CREATE.ACTION, sagaCreateJobSiteDocument)
}

function* sagaUpdateJobSiteDocument(action) {
  try {
    const payload = {
      description: action.description,
      attachment_id: action.attachmentId
    }
    yield call(api.updateJobSiteDocument, payload)
    yield put({ type: constants.JOB_SITE_DOCUMENT_UPDATE.SUCCESS, payload })
    yield call(jobSiteDocumentsFetch, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteDocument() {
  yield takeLatest(constants.JOB_SITE_DOCUMENT_UPDATE.ACTION, sagaUpdateJobSiteDocument)
}

function* sagaDeleteJobSiteDocument(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId,
      jobId: action.jobId
    }
    yield call(api.deleteJobSiteDocument, payload)
    yield put({ type: constants.JOB_SITE_DOCUMENT_DELETE.SUCCESS, payload })
    yield call(jobSiteDocumentsFetch, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteDocument() {
  yield takeLatest(constants.JOB_SITE_DOCUMENT_DELETE.ACTION, sagaDeleteJobSiteDocument)
}

function* createFolder(action) {
  try {
    const payload = {
      name: action.name,
      parentId: action.parentId,
      jobId: action.jobId
    }

    yield call(api.createFolder, payload)
    yield put({ type: constants.JOB_SITE_DOCUMENT_FOLDER_CREATE.SUCCESS, payload })
    yield call(jobSiteDocumentsFetch, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENT_FOLDER_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateFolder() {
  yield takeLatest(constants.JOB_SITE_DOCUMENT_FOLDER_CREATE.ACTION, createFolder)
}

function* updateFolder(action) {
  try {
    const payload = {
      name: action.name,
      folderId: action.folderId
    }

    yield call(api.updateFolder, payload)
    yield put({ type: constants.JOB_SITE_DOCUMENT_FOLDER_UPDATE.SUCCESS, payload })
    yield call(jobSiteDocumentsFetch, { jobId: action.jobId, folderId: action.currentFodlerId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENT_FOLDER_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateFolder() {
  yield takeLatest(constants.JOB_SITE_DOCUMENT_FOLDER_UPDATE.ACTION, updateFolder)
}

function* deleteFolder(action) {
  try {
    const payload = {
      folderId: action.folderId,
      jobId: action.jobId
    }

    yield call(api.deleteFolder, payload)
    yield put({ type: constants.JOB_SITE_DOCUMENT_FOLDER_DELETE.SUCCESS, payload })
    yield call(jobSiteDocumentsFetch, { jobId: action.jobId, folderId: action.currentFolderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_SITE_DOCUMENT_FOLDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteFolder() {
  yield takeLatest(constants.JOB_SITE_DOCUMENT_FOLDER_DELETE.ACTION, deleteFolder)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      jobId: action.jobId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_JOB_DOCUMENT_ATTACHMENT.SUCCESS, payload })
    yield call(jobSiteDocumentsFetch, { jobId: action.jobId, folderId: action.folderId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_JOB_DOCUMENT_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_JOB_DOCUMENT_ATTACHMENT.ACTION, uploadAttachments)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteDocumentsFetch),

    fork(watchJobSiteDocuments),

    fork(watchJobSiteDocumentsS3),

    fork(watchCreateFolder),
    fork(watchUpdateFolder),
    fork(watchDeleteFolder),

    fork(watchCreateJobSiteDocument),
    fork(watchUpdateJobSiteDocument),
    fork(watchDeleteJobSiteDocument),

    fork(watchUploadAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteDocumentSaga.js